import React from 'react';
import BasePageContainer from 'src/components/CommonV2Components/BasePageContainer/BasePageContainer';
import MarginsProductGrid from './MarginsProductGrid';
import Flex from 'src/components/BeaconV2Components/Flex/Flex';
import { BEACON_CHART_SPACING } from 'src/components/Layout/Beacon/BeaconProLayoutConsts';
import BeaconComparableSplineChart from 'src/components/BeaconV2Components/BeaconMetricSplineChart/BeaconComparableSplineChart';
import { ChartContextProvider } from 'src/utils/chartContext/ChartContextGroupContext';
import { CHART_CONTEXT_GROUPS, CHART_NAMES } from 'src/utils/chartContext/chartContextRegistry';

const MarginsPage = () => {
  return (
    <BasePageContainer>
      <Flex flexDirection="column" gap={BEACON_CHART_SPACING}>
        <ChartContextProvider
          group={CHART_CONTEXT_GROUPS.BEACON_RETAILER_GROSS_MARGIN.name}
          chartName={CHART_NAMES.BEACON_RETAILER_GROSS_MARGIN_SPLINE}
        >
          <BeaconComparableSplineChart indexName="sales" fieldName="retailerGrossMargin" />
        </ChartContextProvider>
        <ChartContextProvider
          group={CHART_CONTEXT_GROUPS.BEACON_RETAILER_GROSS_MARGIN_PERCENT.name}
          chartName={CHART_NAMES.BEACON_RETAILER_GROSS_MARGIN_PERCENT_SPLINE}
        >
          <BeaconComparableSplineChart indexName="sales" fieldName="retailerGrossMarginPercent" />
        </ChartContextProvider>
        <ChartContextProvider
          group={CHART_CONTEXT_GROUPS.BEACON_BRAND_COGS.name}
          chartName={CHART_NAMES.BEACON_BRAND_COGS_SPLINE}
        >
          <BeaconComparableSplineChart indexName="sales" fieldName="brandCogs" />
        </ChartContextProvider>
        <ChartContextProvider
          group={CHART_CONTEXT_GROUPS.BEACON_BRAND_GROSS_MARGIN.name}
          chartName={CHART_NAMES.BEACON_BRAND_GROSS_MARGIN_SPLINE}
        >
          <BeaconComparableSplineChart indexName="sales" fieldName="brandGrossMargin" />
        </ChartContextProvider>
        <ChartContextProvider
          group={CHART_CONTEXT_GROUPS.BEACON_BRAND_GROSS_MARGIN_PERCENT.name}
          chartName={CHART_NAMES.BEACON_BRAND_GROSS_MARGIN_PERCENT_SPLINE}
        >
          <BeaconComparableSplineChart indexName="sales" fieldName="brandGrossMarginPercent" />
        </ChartContextProvider>
        <MarginsProductGrid />
      </Flex>
    </BasePageContainer>
  );
};

export default MarginsPage;
